'use client'

import { CATALOG_URL_ID } from 'links/plp/constants'
import type { PlpLinkProps } from 'links/plp/types/PlpLink.types'
import { useMemo } from 'react'
import { env } from 'utils/envManager/envManager'
import { ClientLink } from 'utils/link/client/ClientLink'

export function isCatalogUrl(url: string): boolean {
	return url.includes(`/${CATALOG_URL_ID}/`)
}

export function PlpClientLink({
	href,
	className,
	children,
	linkProps,
	onClick,
	metaAs,
}: Readonly<PlpLinkProps>): React.ReactNode {
	const url = useMemo(() => {
		const baseUrl = href.startsWith('/')
			? new URL(href, env.NEXT_PUBLIC_CURRENT_ORIGIN)
			: new URL(href)

		return baseUrl.href
	}, [href])

	return (
		<>
			{metaAs && <meta itemProp={metaAs} content={url} />}
			<ClientLink
				className={className}
				href={url}
				isLocalizedPath
				prefetch={false}
				onClick={onClick}
				linkProps={linkProps}
			>
				{children}
			</ClientLink>
		</>
	)
}
